import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SchedaIntense, AuthService, WMAIApiService, User } from '../../core';
import { WgisService } from 'src/app/wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-schedaintense-result',
  templateUrl: './schedaintense-result.component.html',
})
export class SchedaintenseResultComponent implements OnInit {

  @Input() schedaintense: SchedaIntense;
  isUserLoggedIn: boolean = false;
  userid: string;

  constructor(
    private auth: AuthService,
    private wmaiservice: WMAIApiService,
    private wgis: WgisService,
    private router: Router,
    private angulartics2: Angulartics2,
    private translateService: TranslateService
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.angulartics2.eventTrack.next( {
      action: 'creaEsperienza',
      properties: { label: 'SchedaIntenseResultCreate' }
    } );

    this.angulartics2.eventTrack.next( {
      action: 'onMouseEnter',
      properties: { schedaintense: 'SchedaIntenseResultMouseEnter'}
    } );

    this.angulartics2.eventTrack.next( {
      action: 'viewInMappa',
      properties: { schedaintense: 'SchedaIntenseResultViewInMappa'}
    } );
  }

  ngOnInit() 
  {   
    if (this.isUserLoggedIn){
      this.userid = this.auth.getIdUser();
    }
  }

  viewInMappa(): void {
    this.wgis.showSchedaIntenseByObj(this.schedaintense);
  }


/**
   * se l'utente è autentificato allora si crea l'esperienza
   */
  creaEsperienza() {
    if (this.schedaintense != null) {
      if (this.isUserLoggedIn) {
        this.wmaiservice.createEsperienza(this.schedaintense.id, this.translateService.getDefaultLang() ).subscribe(data => {
          let newid = data['id'];
          if (newid != null) {
            this.router.navigate(['esperienza/edit', newid]);
          }
        });
      } else {
        this.router.navigate(['login']);
      }
    }
  }

  onMouseEnter(idscheda: number){
    this.wgis.zoomOnSchedaIntense(idscheda);
  }
}
